// The list of file replacements can be found in `angular.json`.

export const environment = {
	autoTimeoutTime: 3600000,
	apiConfig: {
		// apiUrl: 'https://api.dev.platform.axso.co/admin',
		apiUrl: 'http://localhost:7327/admin',
		authPath: 'user',
		// domain: 'api.dev.platform.axso.co',
		domain: 'localhost:7327',
		basic: {
			key: 'gShs9DRRyELt9HyqRYrxar7wrBxF8KPN',
			secret: 'gjssf2RcZsbqZh7qtBUNKVqNm8VD3F4E',
		},
	},
	production: false,
	siteUrl: 'https://admin-develop.eptix.co',
	eddieUrl: '',
	siteTitle: 'Eptix',
	version: '2.9.0',
	google: {
		apiKey: 'AIzaSyBmbWGbEer4PrGt5BHQZep95S-PxwA0pJ0',
		map: {
			initialPosition: {
				lat: 45.4972159,
				lng: -73.6103642,
			},
		},
		measurementId: null,
		tagManagerId: null,
		reCaptcha: {
			siteKey: '',
		},
	},
	support: {
		defaultOrigin: {
			id: '61018cc5467d570d6e112da7',
		},
	},
	mapBox: {
		accessToken: 'pk.eyJ1IjoiZ2JlZ2luIiwiYSI6ImNqdTJqeXdxYjBkOTUzeXBlc2N6aDdseXEifQ.yg3X3KavsDz0sA8wDCtpuw',
		mapUrl: '',
	},
	flexmonster: {
		accessToken: 'Z73C-XG4F3A-592Q35-18023F-5O536N-6V461H-0C542G-3O1E3W-155M2A-1D6R2L-120V',
	},
	session: {
		adminAdditionalFees: 5,
		maxAdminAdditionalFees: 10,
	},
	stripe: {
		usd: {
			key: 'pk_test_dlggygYKLP4DjWlqYaJVqS3r00Y6kxmCqr',
		},
		cad: {
			key: 'pk_test_dlggygYKLP4DjWlqYaJVqS3r00Y6kxmCqr',
		},
	},
	htmlEditorKey: '8lwexayaehb2tz1lh9yk4lw4hn9ehbp54j3g5cjfnugz5l39',
	mainNetwork: {
		id: '5cdd70eea2979e7e90c03562',
		name: {
			fr: 'Circuit Électrique',
			en: 'Electric Circuit',
		},
		fullName: {
			fr: 'Circuit Électrique inc.',
			en: 'Electric Circuit inc.',
		},
		abbreviation: {
			fr: 'CÉ',
			en: 'EC',
		},
		brand: null,
	},
	defaultCurrency: {
		code: 'CAD',
		digits: 2.0,
		symbol: '$',
	},
	menuItems: [
		{
			path: 'dashboard',
			moduleName: 'dashboard',
			pageName: 'details',
			labelKey: 'DASHBOARD.NAVIGATION-LABEL',
			icon: 'dashboard',
			submenu: [],
		},
		{
			path: 'customers',
			moduleName: 'customers',
			pageName: 'list',
			labelKey: 'CUSTOMER.NAVIGATION-LABEL',
			icon: 'people',
			submenu: [],
		},
		{
			path: 'tickets',
			moduleName: 'tickets',
			pageName: 'list',
			labelKey: 'TICKET.NAVIGATION-LABEL',
			icon: 'headset_mic',
			submenu: [],
			pendingType: 'ticketsAssigned',
		},
		{
			path: 'incidents',
			moduleName: 'incidents',
			pageName: 'list',
			labelKey: 'INCIDENT.NAVIGATION-LABEL',
			icon: 'car_crash',
			submenu: [],
			pendingType: 'openIncidents',
		},
		{
			path: 'sites',
			moduleName: 'sites',
			pageName: 'list',
			labelKey: 'SITE.NAVIGATION-LABEL',
			icon: 'ev_station',
			submenu: [],
			pendingType: 'incompleteSiteCount',
		},
		{
			path: 'partners',
			moduleName: 'partners',
			pageName: 'list',
			labelKey: 'PARTNER.NAVIGATION-LABEL',
			icon: 'contacts',
			submenu: [],
		},
		{
			path: 'transactions',
			moduleName: 'transactions',
			pageName: 'list',
			labelKey: 'TRANSACTION.NAVIGATION-LABEL',
			icon: 'receipt',
			submenu: [],
		},
		{
			path: 'refunds',
			moduleName: 'refunds',
			pageName: 'list',
			labelKey: 'REFUND.NAVIGATION-LABEL',
			icon: 'settings_backup_restore',
			submenu: [],
		},
		{
			path: 'sessions',
			moduleName: 'sessions',
			pageName: 'list',
			labelKey: 'SESSION.NAVIGATION-LABEL',
			icon: 'update',
			submenu: [],
		},
		{
			path: 'merchants',
			moduleName: 'merchants',
			pageName: 'list',
			labelKey: 'MERCHANT.NAVIGATION-LABEL',
			icon: 'store',
			submenu: [],
			pendingType: 'pendingMerchants',
		},
		// {
		//     path: 'continuity-index',
		//     labelKey: 'CONTINUITY-INDEX.NAVIGATION-LABEL',
		//     icon: 'av_timer',
		//     submenu: [],
		// },
		{
			path: 'offers',
			moduleName: 'offers',
			pageName: 'list',
			labelKey: 'OFFER.NAVIGATION-LABEL',
			icon: 'local_offer',
			submenu: [],
			pendingType: 'pendingOffers',
		},
		{
			path: 'memberStatusRequests',
			moduleName: 'memberStatusRequest',
			pageName: 'list',
			labelKey: 'MEMBER-STATUS-REQUEST.NAVIGATION-LABEL',
			icon: 'badge',
			submenu: [],
			pendingType: 'pendingCustomerStatusRequestCount',
		},
		{
			path: 'memberCards',
			moduleName: 'memberCards',
			pageName: 'list',
			labelKey: 'MEMBER-CARD.NAVIGATION-LABEL',
			icon: 'credit_card',
			submenu: [],
		},
		{
			path: 'memberCardRequests',
			moduleName: 'memberCardRequests',
			pageName: 'list',
			labelKey: 'MEMBER-CARD-REQUEST.NAVIGATION-LABEL',
			icon: 'card_membership',
			submenu: [],
			pendingType: 'pendingMemberCardRequestCount',
		},
		{
			path: 'feedback',
			moduleName: 'feedback',
			pageName: 'list',
			labelKey: 'FEEDBACK.NAVIGATION-LABEL',
			icon: 'star',
			submenu: [],
		},
		{
			path: 'garages',
			moduleName: 'garages',
			pageName: 'list',
			labelKey: 'GARAGE.NAVIGATION-LABEL',
			icon: 'garage',
			submenu: [],
		},
		{
			path: 'gifts',
			moduleName: 'gifts',
			pageName: 'list',
			labelKey: 'GIFT.NAVIGATION-LABEL',
			icon: 'redeem',
			submenu: [],
		},
		{
			path: 'benefits',
			moduleName: 'benefits',
			pageName: 'list',
			labelKey: 'BENEFIT.NAVIGATION-LABEL',
			icon: 'loyalty',
			submenu: [],
		},
		{
			path: 'finances',
			moduleName: 'finances',
			pageName: 'list',
			labelKey: 'FINANCE.NAVIGATION-LABEL',
			icon: 'monetization_on',
			submenu: [],
		},
		{
			path: 'reports',
			moduleName: 'reports',
			pageName: 'list',
			labelKey: 'REPORT.NAVIGATION-LABEL',
			icon: 'bar_chart',
			submenu: [],
		},
		{
			path: 'settings',
			moduleName: 'settings',
			pageName: 'list',
			labelKey: 'SETTING.NAVIGATION-LABEL',
			icon: 'settings',
			submenu: [],
		},
	],
	footerMenuItems: [
		{
			path: 'auth/terms-of-use',
			moduleName: 'auth/terms-of-use',
			pageName: 'details',
			labelKey: 'TERMS-OF-USE.NAVIGATION-LABEL',
			submenu: [],
		},
		{
			path: '',
			pageName: 'details',
			moduleName: 'auth/terms-of-use',
			externalUrl: {
				en: 'https://lecircuitelectrique.com/en/faq-partenaires/',
				fr: 'https://lecircuitelectrique.com/fr/faq-partenaires/',
			},
			labelKey: 'FAQ.NAVIGATION-LABEL',
			submenu: [],
		},
	],
	firebase: {
		apiKey: 'AIzaSyBmbWGbEer4PrGt5BHQZep95S-PxwA0pJ0',
		authDomain: 'lecircuitelectrique-dev.firebaseapp.com',
		databaseURL: 'https://lecircuitelectrique-dev.firebaseio.com',
		projectId: 'lecircuitelectrique-dev',
		storageBucket: 'lecircuitelectrique-dev.appspot.com',
		messagingSenderId: '356334598493',
		appId: '1:356334598493:web:482c4d909bf37af58dd0b4',
		measurementId: 'G-FMJRNRKKRG',
	},
	FF_CONFIG_ENABLED: true,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
